import { FooterShell, FooterInner, FooterLinks } from "./Footer.styled";
import { PIERSOFT_LOGO } from "../../constants/assets";

export default function Footer() {
  return (
    <FooterShell>
      <FooterInner>
        <img
          src={PIERSOFT_LOGO}
          alt="Piersoft Technologies"
          style={{ height: 50 }}
        />
        <FooterLinks>
          <a href="#about">About</a>
          <a href="#features">Features</a>
          <a href="#ready">Ready to digitalize</a>
        </FooterLinks>
      </FooterInner>
    </FooterShell>
  );
}
